<template>
  <TemplateRegistro :titulo="titulo" :texto="texto">
    <label for="uname"><strong>Teléfono Móvil</strong></label>
    <span class="telefono">{{ telefono }}</span>

    <PanelMensajes :mensaje="error" clase="error" />

    <button v-if="!error" class="pure-button ripple" @click.prevent="submit">
      <strong>El teléfono es correcto</strong>
    </button>

    <button
      v-if="!error"
      class="pure-button ripple"
      style="background-color: red"
      @click.prevent="cancel"
    >
      <strong>No es mi teléfono</strong>
    </button>

    <button v-if="error" class="pure-button ripple" @click.prevent="volver">
      <strong>Volver</strong>
    </button>
  </TemplateRegistro>
</template>

<script>
export default {
  data() {
    return {
      error: "",
      titulo: "Verificación de teléfono móvil",
      texto:
        "Vamos a mandarte un SMS con un código de verificación (PIN) a tu teléfono móvil. " +
        "Comprueba que tu nº de móvil termina como aparece a continuación:"
    };
  },

  computed: {
    telefono() {
      return this.$store.state.registroInfo.telefono;
    },
    telefAtencion() {
      return this.$store.state.telefonoAtencion;
    },
    telefAtencionGratuito(){
      return this.$store.state.telefonoAtencionGratuito;
    }
  },

  methods: {
    submit: async function() {
      await this.$store.dispatch("mandarPin");
      this.$router.replace({ name: "registroPin" });
    },

    volver() {
      this.$router.replace({ name: "login" });
    },

    cancel() {
      this.error =
        "Debe ponerse en contacto con MMT Seguros para dar de alta un número de teléfono movil. Llame al " +
        this.telefAtencionGratuito + " o " + this.telefAtencion +
        " o contacte con su oficina.";

      return;
    }
  }
};
</script>

<style lang="scss" scoped></style>
